<template>
  <div>
    <progress-bar class="c-progress-header" :value="3" :max="6" label="stappen">Progress</progress-bar>
    <h1 class="c-heading-1">Je {{numberOfTopics}} bollen staan klaar</h1>
    <p>Op basis van je sectorkeuze staan er {{numberOfTopics}} trends klaar.
    Elke trend is een bol. 
    Aan jou om in te schatten hoe groot de impact van deze trend kan zijn op jouw sector
    en na te gaan over hoe ver je hier vandaag al in staat. Het doel is om je meer inzicht te geven en je aan het denken te zetten.
    </p>
    <p>Swipe naar links of rechts om de bollen te alvast te verkennen. We gaan straks aan de slag.</p>
    <div class="c-circles" v-touch:swipe.right="swipeRightHandler" v-touch:swipe.left="swipeLeftHandler">
      <a
        class="arrow-left"
        v-bind:class="{ active: isLeftArrowActive }"
        href="#"
        @click.prevent="previous()"
      >Previous</a>
        <topic-circle
          v-for="(topic, key) in randomTopics"
          :key="key"
          :label="topic.title"
          :image="'/images/' + topic.image"
          :size="2"
          :static="true"
          :no-opinion="hasNoOpinion(key)"
        />
        <!-- toggle NoOpinion -->
        <!-- <button
          class="toggle-no-opinion"
          @click.prevent="toggleNoOpinion(key)"
        >{{ hasNoOpinion(key) ? '+': 'x' }}</button>
        -->
      <a
        class="arrow-right"
        :class="{ active: isRightArrowActive }"
        href="#"
        @click.prevent="next()"
      >Next</a>
    </div>
    <div class="c-toolbar">
      <navigation-button to="coworkers">Ga verder</navigation-button>
    </div>
  </div>
</template>

<script>
import NavigationButton from "../components/NavigationButton";
import ProgressBar from "../components/ProgressBar";
import TopicCircle from "../components/TopicCircle";
import topicMixins from "../mixins/Topics.js";
export default {
  mixins: [topicMixins],
  components: {
    NavigationButton,
    TopicCircle,
    ProgressBar
  },
  data() {
    return {
      startIndex: 0
    };
  },
  computed: {
    isLeftArrowActive() {
      return this.startIndex > 0;
    },
    isRightArrowActive() {
      return this.startIndex < this.numberOfTopics - 3;
    },
    randomTopics() {
      let topics = this.$store.getters.filteredTopics;
      let keys = Object.keys(topics);
      let result = {
        [keys[this.startIndex]]: topics[keys[this.startIndex]],
        [keys[this.startIndex + 1]]: topics[keys[this.startIndex + 1]],
        [keys[this.startIndex + 2]]: topics[keys[this.startIndex + 2]]
      };
      return result;
    },
    numberOfTopics() {
      return Object.keys(this.$store.getters.filteredTopics).length;
    }
  },
  methods: {
    next() {
      if (this.startIndex < this.numberOfTopics - 3)
        this.startIndex = this.startIndex + 1;
    },
    previous() {
      if (this.startIndex > 0) this.startIndex = this.startIndex - 1;
    },
    swipeLeftHandler() {
      this.previous();
    },
    swipeRightHandler() {
      this.next();
    },
  }
};
</script>

<style lang="scss">
.c-circles {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 4rem 0 2rem;
}

.c-circles .select-topic-circle {
  display: block;
  position: relative;
  margin: 0 2.5rem;
}

.c-circles .select-topic-circle .toggle-no-opinion {
  position: absolute;
  right: .25rem;
  top: .25rem;
  background-color: red;
  border-color: red;
  box-shadow: red 1px 1px 5px;
  cursor: pointer;
}

.c-circles .select-topic-circle.has-no-opinion .toggle-no-opinion {
  background-color: green;
  border-color: green;
  box-shadow: green 1px 1px 5px;
}

.c-circles > *:nth-child(3) {
  margin: 0 -3rem;
  z-index: 5;
}

.c-circles > *:nth-child(2),
.c-circles > *:nth-child(4) {
  opacity: 0.5;
  transform: scale(0.8);
}

.arrow-left {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid white;
  text-indent: -9999px;
  display: inline-block;
  visibility: hidden;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
  text-indent: -9999px;
  display: inline-block;
  visibility: hidden;
}
.active {
  visibility: visible;
}
</style>
